module.exports = __webpack_public_path__ + "static/img/dandelion.c7c7cc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/neutral/dandelion.png
// module id = 2Dqc
// module chunks = 0